import { AbstractGameService } from '../../core/abstractions/AbstractGameService';
import { GameApplicationType, GameMode, GameSceneType } from '../../core/enums';
import { RealGameStrategy } from './gameServiceStrategies/RealGameStrategy';
import { DemoGameStrategy } from './gameServiceStrategies/DemoGameStrategy';
import {
  BONUS_BALL_CRACK, BONUS_COST_AMOUNT,
  BONUS_GAME_BALLS, BONUS_GAME_BALLS_CRACKS,
  FREE_SPIN_COUNT_STATE,
  GAME_APPLICATION_MODE_STATE,
  GAME_APPLICATION_SCENE_STATE,
  GAME_APPLICATION_TYPE_STATE,
  MULTIPLIER_STATE,
} from '../../stateManagment';
import { partnerService } from '../helperServices/PartnerService';
import { gamePadService } from '../helperServices/GamePadService';
import { bigWinService } from '../helperServices/BigWinService';
import { userService } from '../helperServices/UserService';
import { DEMO_BALANCE } from '../../core/constats';
import { jsonParser } from '../../core/helpers/jsonParser';
import { getBallColorAndCrackState } from '../../core/helpers/getBallColorAndCrackState';

class GameService extends AbstractGameService {
  constructor(strategies) {
    super();
    this.strategies = strategies;
  }

  get mode() {
    return GAME_APPLICATION_MODE_STATE.getValue();
  }

  get isMobile() {
    return GAME_APPLICATION_TYPE_STATE.getValue() === GameApplicationType.mobile;
  }

  get isBonus() {
    return GAME_APPLICATION_SCENE_STATE.getValue() === GameSceneType.bonus;
  }

  set mode(value) {
    GAME_APPLICATION_MODE_STATE.next(value);
  }

  get isRealMode() {
    return this.mode === GameMode.real;
  }

  get instance() {
    return this.strategies[this.mode];
  }

  async spin() {
    return this.instance.spin();
  }

  async bonusSpin() {
    return this.instance.bonusSpin();
  }

  async buyBonus() {
    return this.instance.buyBonus();
  }

  async preBonus(bonusId) {
    return this.instance.preBonusSpin(bonusId);
  }

  async getBalance() {
    return this.instance.getBalance();
  }

  async getInitialState(params, config) {

    return this.instance.getInitialState({ params }, config).then((response) => {
      gamePadService.quickBets = response.quickBets;
      bigWinService.maxWinLimit = response.maxWinLimit;
      partnerService.currency = response.currencyCode;
      if (this.isRealMode) {
        if (response.bonusSpinInfo) {
          const { remainingSpinCount, multiplier } = response.bonusSpinInfo;
          const bonusData = jsonParser(response.bonusSpinInfo.bonusData.bonusInfo);
          const { colors, crackStates } = getBallColorAndCrackState(bonusData.balls);
          GAME_APPLICATION_SCENE_STATE.next(GameSceneType.bonus);
          BONUS_GAME_BALLS.next(colors);
          BONUS_BALL_CRACK.next(bonusData.multiplier.crackedcount);
          BONUS_GAME_BALLS_CRACKS.next(crackStates);
          FREE_SPIN_COUNT_STATE.next(remainingSpinCount);
          MULTIPLIER_STATE.next(multiplier);
        }
        userService.balance = response.balance;
      } else {
        userService.balance = DEMO_BALANCE;
      }
      return response;
    });
  }

  getBonusLastState() {
    return this.instance
      .getInitialState({ ...this._createInitialStateParams() })
      .then(data => {
        if (data.bonusSpinInfo) {
          const {
            multiplier,
            remainingSpinCount,
          } = data.bonusSpinInfo;

          if (data.spinInfo) {
            const { amount } = data.spinInfo;
            BONUS_COST_AMOUNT.next(amount);
          }

          MULTIPLIER_STATE.next(multiplier);
          FREE_SPIN_COUNT_STATE.next(remainingSpinCount);
          return data.bonusSpinInfo;
        }
        return null;
      });
  }
}

export const gameService = new GameService({
  [GameMode.real]: new RealGameStrategy(),
  [GameMode.demo]: new DemoGameStrategy(),
});
